import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {ReactComponent as IconDesc} from "../../../assets/icon/icon-desc.svg"
import {ReactComponent as IconAsc} from "../../../assets/icon/icon-asc.svg"
import StaticsProduceSkus from "./StaticsProduceSkus"

class StaticsProduce3D extends Component {
    _onClick = (key, sort) => {
        const {onChangeSort} = this.props

        if (typeof onChangeSort === 'function') {
            onChangeSort(key, sort)
        }
    }
    _calculatorTotalArray = (arrTotal, key) => {
        return arrTotal.reduce((accumulator, currentValue) => accumulator + currentValue[key], 0)
    }

    _getTotal = (data, key) => {
        if (data.find(i => i[key] >= 0)) {
            return this._calculatorTotalArray(data, key) > 0
                ? this._calculatorTotalArray(data, key)
                : '-'
        }
    }

    render() {
        const {data3D, sort, desc, loading, error} = this.props

        return (
            <div className="StaticsProduce3D">
                <div className="header-title d-flex justify-content-between align-items-center mb-3">
                    <h5 className='mb-0'>Sản phẩm 3D</h5>
                    <StaticsProduceSkus {...this.props} typeSku="3D"/>
                </div>
                <div className="data-content">
                    <table className='table table-bordered'>
                        <thead>
                        <tr>
                            <th>SKU</th>
                            <th className='Pending CustomHead' onClick={() => this._onClick('pending', !desc)}>
                                Pending
                                <span className={`Sort ${sort === 'pending' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Printing CustomHead' onClick={() => this._onClick('printing', !desc)}>
                                Printing
                                <span className={`Sort ${sort === 'printing' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Printed CustomHead' onClick={() => this._onClick('printed', !desc)}>
                                Đã in
                                <span className={`Sort ${sort === 'printed' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Transferred CustomHead' onClick={() => this._onClick('transferred', !desc)}>
                                Đã ép
                                <span className={`Sort ${sort === 'transferred' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Confirmed CustomHead' onClick={() => this._onClick('confirmed', !desc)}>
                                QC sau ép
                                <span className={`Sort ${sort === 'confirmed' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Sewing CustomHead' onClick={() => this._onClick('sewing', !desc)}>
                                Đang may
                                <span className={`Sort ${sort === 'sewing' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Completed CustomHead' onClick={() => this._onClick('completed', !desc)}>
                                Hoàn thành
                                <span className={`Sort ${sort === 'completed' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Labelled CustomHead' onClick={() => this._onClick('labelled', !desc)}>
                                Labelled
                                <span className={`Sort ${sort === 'labelled' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                            <th className='Total CustomHead' onClick={() => this._onClick('total', !desc)}>
                                Tổng
                                <span className={`Sort ${sort === 'total' ? 'active' : ''} ${desc}`}>
                                    <IconAsc/>
                                    <IconDesc/>
                                </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                !!error && <tr>
                                    <td colSpan={9} className='text-danger text-left'>{error}</td>
                                </tr>
                            }

                            {
                                !!loading && <tr>
                                    <td colSpan={9} className='text-left'>Loading...</td>
                                </tr>
                            }
                            {
                                !!data3D && data3D.length > 0 &&
                                <tr className='Total3d'>
                                    <td className='Sku'></td>
                                    <td className='Pending'>{this._getTotal(data3D, 'pending')}</td>
                                    <td className='Printing'>{this._getTotal(data3D, 'printing')}</td>
                                    <td className='Printed'>{this._getTotal(data3D, 'printed')}</td>
                                    <td className='Transferred'>{this._getTotal(data3D, 'transferred')}</td>
                                    <td className='Confirmed'>{this._getTotal(data3D, 'confirmed')}</td>
                                    <td className='Sewing'>{this._getTotal(data3D, 'sewing')}</td>
                                    <td className='Completed'>{this._getTotal(data3D, 'completed')}</td>
                                    <td className='Labelled'>{this._getTotal(data3D, 'labelled')}</td>
                                    <td className='Total'>{this._getTotal(data3D, 'total')}</td>
                                </tr>
                            }

                            {
                                !!data3D && data3D.length > 0 && data3D.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className='Sku'>{item.sku}</td>
                                            <td className='Pending'>{item.pending === 0 ? '-' : item.pending}</td>
                                            <td className='Printing'>{item.printing === 0 ? '-' : item.printing}</td>
                                            <td className='Printed'>{item.printed === 0 ? '-' : item.printed}</td>
                                            <td className='Transferred'>{item.transferred === 0 ? '-' : item.transferred}</td>
                                            <td className='Confirmed'>{item.confirmed === 0 ? '-' : item.confirmed}</td>
                                            <td className='Sewing'>{item.sewing === 0 ? '-' : item.sewing}</td>
                                            <td className='Completed'>{item.completed === 0 ? '-' : item.completed}</td>
                                            <td className='Labelled'>{item.labelled === 0 ? '-' : item.labelled}</td>
                                            <td className='Total'>{item.total === 0 ? '-' : item.total}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

StaticsProduce3D.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    data3D: PropTypes.array.isRequired,
    sort: PropTypes.string,
    desc: PropTypes.bool,
    onChangeSort: PropTypes.func.isRequired,
    onChangeListSku: PropTypes.func.isRequired
}

export default StaticsProduce3D